import { TranslationKeys } from '../../../../core/constants/translationKeys';
import { ColumnsType } from '../../../../core/constants/columnsType';
import { isMobile } from '../../../../core/helpers/isMobile';
import { popupStore } from '../../../../store/popupStore';
import { PopupTypes } from '../../../../core/constants/popupTypes';
import { checkHashStore } from '../../../../store/checkHashStore';
import { userInfoStore } from '../../../../store/userInfoStore';
import { isPG, isTopC } from '../../../../core/helpers/skinHelper';
import { cryptoCurrencies } from '../../../../core/constants/cryptoCurrencies';
import { partnerSkinNames } from '../../../../core/constants/partnerSkinEnums';

export const footballAnimationSourceNames = {
  playersAnimation: 'playersAnimation',
  ballAnimation: 'ballAnimation',
};

export const gameResources = (partnerSkin) => {
  const animFileName = partnerSkinNames[partnerSkin];
  const footballAnimationSourcesWeb = {
    playersAnimation: {
      name: footballAnimationSourceNames.playersAnimation,
      path: `animations/football_${animFileName}/footballPlayersWeb.json`,
      config: {
        metadata: {
          spineAtlasFile: `animations/football_${animFileName}/footballPlayersWeb.atlas`,
        },
      },
    },
  };

  const footballAnimationSourcesMobile = {
    playersAnimation: {
      name: footballAnimationSourceNames.playersAnimation,
      path: `animations/football_${animFileName}/footballPlayersMobile.json`,
      config: {
        metadata: {
          spineAtlasFile: `animations/football_${animFileName}/footballPlayersMobile.json`,
        },
      },
    },
  };
  return [
    ...Object.values(isMobile() ? footballAnimationSourcesMobile : footballAnimationSourcesWeb),
  ];
};

export const FootballGameContainers = {
  players: 'players',
};

export const playersSkinName = {
  player1: 'Another white dude',
  player2: 'Asian dude',
  player3: 'Black dude',
  player4: 'white dude With beard',
};

export const playersSkinNames = [
  playersSkinName.player1,
  playersSkinName.player2,
  playersSkinName.player3,
  playersSkinName.player4,
];

export const footballPlayerAnimationName = {
  animation1: 'animation1',
  animation2: 'animation2',
  fall: 'fall',
  idle: 'idle',
};

export const FootballCanvasConfigWeb = {
  backgroundAlpha: 0,
  width: 2050,
  height: 1360,
};

export const FootballCanvasConfigMobile = {
  backgroundAlpha: 0,
  width: 720,
  height: 728,
};

export const FOOTBALL_GAME_ID = 51;

export const FootballLiveBetsColumns = [
  {
    title: TranslationKeys.UserId,
    dataKey: 'userId',
    isShow: true,
    columnType: ColumnsType.MaskNameFormat,
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'cashOutOdd',
    isShow: true,
    additionalInfoRenderer: (spinInfo) => `${spinInfo.odd}x`,
    columnType: ColumnsType.Default,
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const FootballBetHistoryColumns = [
  {
    title: TranslationKeys.RoundId,
    dataKey: 'id',
    isShow: true,
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo) => (
      <i
        onClick={(e) => {
          e.stopPropagation();
          popupStore.open({ name: PopupTypes.Fairness, spinInfo });
          checkHashStore.setSpinInfo({
            salt: spinInfo.salt,
            key: spinInfo.key,
            hash: spinInfo.hash,
          });
        }}
        className='icon-fairness-fill cpt-table-column-icon'
      />
    ),
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'cashOutOdd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const FOOTBALL_RULES_KEYS = new Array(isPG() ? 16 : 7)
  .fill(null)
  .map((item, index) => index + 1);
export const FOOTBALL_ABOUT_HASH_KEYS = new Array(16).fill(null).map((item, index) => index + 1);
